import digitalData from 'digital-data';

const sponsoredTracking = (sponsoredViewBeacon) => {
  if (sponsoredViewBeacon) {
    const img = document.createElement('img');
    img.className = 'onviewbeacon';
    img.src = sponsoredViewBeacon;
    img.style = 'display: none';
    document.body.appendChild(img);
  }
};

export const impressionProvider = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('impression.trigger', ({ output }) => {
    sponsoredTracking(output?.impression?.sponsoredViewBeacon);

    const ddoEvent = {
      category: {
        primaryCategory: 'batch'
      },
      eventInfo: {
        eventName: 'viewport impression'
      },
      clickID: output?.clickID,
      container: output?.container,
      impression: output?.impression
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
